/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumVerificaResponseTipoVerificaEnum =
  (typeof EnumVerificaResponseTipoVerificaEnum)[keyof typeof EnumVerificaResponseTipoVerificaEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumVerificaResponseTipoVerificaEnum = {
  ERRORE: 'ERRORE',
  WARNING: 'WARNING',
  OK: 'OK',
} as const;
